export default "__VITE_ASSET__SF9BsiGp__"